import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';

const StoreUploadModal = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        zIndex: '100',
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}>
      <Box
        sx={{
          minWidth: '286px',
          minHeight: '160px',
          borderRadius: '15px',
          border: '1px solid #00000010',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-around',
          background: '#fff',
          padding: '20px',
        }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mt: '18px',
            width: '100%',
            justifyContent: 'center',
            flexDirection: 'column',
          }}>
          <Typography sx={{ fontWeight: 800, fontSize: '14px', lineHeight: '17px', textAlign: 'center', color: 'red' }}>
            {t('Uploading')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StoreUploadModal;
